export const dictionaryHE = {
  Book: "הזמנה",
  Continue: "המשך",
  "Continue to checkout": "להמשיך לקופה",
  "Enhance your booking": "שדרגו את ההזמנה",
  "/hr": "לשעה",
  hr: "שעה",
  hrs: "שעות",
  min: "דקה",
  mins: "דקות",
  "1 hr": "שעה אחת",
  people: "אנשים",
  person: "אדם",
  Location: "מקום",
  "City: Any": "עיר",
  "State: Any": "מדינה",
  "Location: Any": "מיקום",
  "Capacity: Any": "מספר אנשים",
  Filter: "סנן",
  Filters: "מסננים",
  Office: "משרד",
  "{count} offerings at {locationName}": "{count} הצעות ב{locationName}",
  "On Demand": "לפי דרישה",
  Memberships: "חברויות",
  Any: "כל הגדלים",
  "Any location": "כל הגדלים",
  "Any city": "כל הגדלים",
  view: "נוף",
  "Invitations already sent to:": "הזמנות כבר נשלחו אל:",
  and: "ו-",
  "Available on {date}": "זמין ב {date}",
  "Best price available today": "המחיר הטוב ביותר זמין היום",
  "Best price available tomorrow": "המחיר הטוב ביותר זמין מחר",
  "Best price available on {date}": "המחיר הטוב ביותר זמין ב {date}",
  "No available space": "אין מקום פנוי",
  "View More": "ראה עוד",
  "Additional offices at this location": "משרדים נוספים במיקום זה",
  Floor: "קומה",
  "With window": "משרד עם חלון",
  "Day offices at-{locationName}": "משרדים יומיים ב-{locationName}",
  "Not sure?": "לא בטוחים?",
  "Talk with us": "דברו איתנו",
  "We couldn't get a price for this selection. Please try again.":
    "לא הצלחנו לחשב מחיר עבור הבחירה הזו. אנא נסו שוב.",
  "We are sorry, but there is no availability for 1 pass":
    "אנו מצטערים, אך אין זמינות עבור מעבר אחד",
  "We are sorry, but this date is unavailable at this location. Please pick a different date":
    "אנו מצטערים, אך תאריך זה אינו זמין במיקום זה. אנא בחרו תאריך אחר",
  "We are sorry, but there is no availability for {number of passes} passes":
    "אנו מצטערים, אך אין זמינות עבור {number of passes} כרטיסים",
  "and we may be able to help you find a solution.":
    "ואולי נוכל לעזור לך למצוא פתרון.",
  max: "מקסימום",
  "Have more questions?": "יש לכם שאלות נוספות?",
  "Visit our FAQ": "בקרו בעמוד השאלות הנוספות שלנו",
  "Frequently asked questions": "שאלות נפוצות",
  Directions: "הוראות הגעה",
  "is located at": "נמצא ב",
  "Not available": "לא זמין",
  Total: 'סה"כ',
  to: "עד",
  "/day": "ליום",
  "/hour": "/שָׁעָה",
  "/month": "לחודש",
  "Quantity:": "כַּמוּת:",
  Quantity: "כַּמוּת",
  Save: "החל",
  When: "מתי",
  Back: "חזרה",
  day: "יום",
  days: "ימים",
  "1 day": "יום אחד",
  "{number of days} days": "{number of days} ימים",
  "Valid for {numberOfDays} day from purchase":
    "בתוקף ל-{numberOfDays} יום מיום הרכישה",
  "Valid for {numberOfDays} days from purchase":
    "בתוקף ל-{numberOfDays} ימים מיום הרכישה",
  "1 hour": "שעה אחת",
  "2 hours": "שעתיים",
  "{number of hours} hours": "{number of hours} שעות",
  "1 entry": "1 כניסה",
  "{number of entries} entries": "{number of entries} גישות",
  entry: "כניסה",
  entries: "גישות",
  Close: "סגירה",
  Amenities: "שירותים",
  "per guest": "למשתתף",
  "fixed rate": "מחיר קבוע",
  "per item": "לפריט",
  "for this space": "לחלל זה",
  "per day": "ליום",
  "per booking": "להזמנה",
  "per guest, daily": "למשתתף, יומי",
  "per item, daily": "לפריט, יומי",
  Included: "כלול",
  "Add-ons": "תוספות",
  "Powered by": "נתמך על ידי",
  Privacy: "פרטיות",
  Terms: "תנאים",
  hour: "שעה",
  hours: "שעות",
  QTY: "כַּמוּת",
  Subtotal: "סכום ביניים",
  "Cancel for free up to {duration} before your booking":
    "ביטול חינם עד {duration} לפני ההזמנה",
  "Cancel for free up to ": "ביטול חינם עד ",
  "Cancel for free up to {time} the day before your booking":
    "ביטול חינם עד {time} ביום שלפני ההזמנה",
  "Fits: {capacity} people max": "מתאים: {capacity} אנשים מקסימום",
  "Free cancellation before {time} on {date}":
    "ביטול חינם לפני {time} בתאריך {date}",
  "This booking is non-refundable.": "לא ניתן לקבל החזר",
  "{max} max": "{max} מקסימום",
  "Up to {capacity} people": "מתאים לעד {capacity} אנשים",
  "Up to {capacity} person": "מתאים לעד {capacity} איש",
  "End time": "זמן סיום",
  "Start time": "שעת התחלה",
  "View all images": "צפייה בכל התמונות",
  "Full name": "שם מלא",
  "Phone number": "מספר טלפון",
  Email: "אימייל",
  "Number of expected guests": "מספר האורחים הצפויים",
  "Company Name": "שם החברה",
  "Street address": "כתובת",
  "City / Town": "עיר",
  "State / Province / Region": "מדינה / פרובינציה / אזור",
  "State / Province / Region (optional)":
    "מדינה / פרובינציה / אזור (אופציונלי)",
  "Postal code": "מיקוד",
  Country: "מדינה",
  "Tax / VAT / ID number": "ח.פ / ת.ז",
  "Enter a promo code": "הכניסו קוד קופון",
  "The promotion code is invalid or has expired.":
    "קוד הקופון שהזנת אינו זמין או שתוקפו פג.",
  "Promo code": "קוד קופון",
  "Payment details": "פרטי העסק",
  "Confirm and Pay": "אישור",
  "You won't be charged unless your request is accepted.":
    "לא תחויב אלא אם כן הבקשה שלך תאושר.",
  "Request to Book": "בקשה להזמנה",
  "Request to Subscribe": "בקשה להרשמה",
  "Continue to payment": "המשך לתשלום",
  "This crash has been reported to us and we will work on resolving the issue as quickly as possible.":
    "התרסקות זו דווחה לנו ואנו נעבוד על פתרון הבעיה במהירות האפשרית.",
  "By clicking on Confirm and Pay I agree to the":
    "על ידי לחיצה על אשר ושלם אני מסכים ל",
  "terms and conditions": "תנאים",
  "Billing details": "פרטי העסק",
  "Your details": "פרטים אישיים",
  Apply: "הזן",
  "Submitting your request": "מגיש את בקשתך",
  "Please add your full name": "אנא הוסף את שמך המלא",
  "Please agree to the terms and conditions": "אנא הסכימו לתנאים ולהגבלות",
  "Please add your company name": "אנא הוסף את שם החברה שלך",
  "Please add your phone number": "אנא הוסף את מספר הטלפון שלך",
  "Please enter valid phone number": "אנא הזן מספר טלפון תקף",
  "Please add your email": 'אנא הוסף את הדוא"ל שלך',
  "Please enter valid email": 'אנא הזינו דוא"ל חוקי',
  "Please add billing street address": "אנא הוסף כתובת לחיוב",
  "Please add billing city": "אנא הוסף עיר חיוב",
  "Please add billing state / province / region":
    "אנא הוסף מדינה / פרובינציה / אזור חיוב",
  "Please add postal code": "אנא הוסף מיקוד",
  "Please add billing country": "אנא הוסף ארץ חיוב",
  "Please add tax information": "אנא הוסף פרטי מס",
  "Invalid Israel tax id": "מזהה מס ישראלי לא חוקי",
  "Let's talk": "בוא נדבר",
  "We would be happy to provide you with more information and answer your specific office needs.":
    "נשמח להעניק לך מידע נוסף וייעוץ חינם לענות על צרכי המשרד הספציפיים שלך.",
  "First Name": "שם פרטי",
  "Last Name": "שם משפחה",
  "How can we help?": "איך אנחנו יכולים לעזור?",
  Submit: "שלח",
  "Could not get order confirmation": "לא ניתן היה לקבל אישור הזמנה",
  "Your payment could not be completed. Please check your card details or try another payment method.":
    "לא ניתן היה להשלים את התשלום. בדקו את פרטי הכרטיס או נסו אמצעי תשלום אחר.",
  "Someone else just booked this space. No payment was taken — the hold on your card will disappear shortly.":
    "מישהו אחר הזמין את החלל הזה כרגע. לא בוצע חיוב — ההקפאה בכרטיס שלכם תיעלם בקרוב.",
  "An add-on you selected just sold out for that date. No payment was taken — the hold on your card will disappear shortly.":
    "תוספת שבחרת אזלה כרגע לאותו תאריך. לא בוצע חיוב — ההקפאה בכרטיס שלכם תיעלם בקרוב.",
  "Choose another time": "בחרו מועד אחר",
  "Stripe was not loaded": "פס לא נטען",
  "The session has expired. Please refresh the page and try again.":
    "פג תוקף ההפעלה. אנא רענן את הדף ונסה שוב.",
  "Card component not found": "רכיב הכרטיס לא נמצא",
  "Payment unsuccessful": "התשלום לא הצליח",
  "Redirecting you to confirmation page": "מפנה אותך לדף האישור",
  Payment: "תשלום",
  "Confirmed without payment": "אושר ללא תשלום",
  "N/A": "N/A",
  "Ending with {last4}": "מסתיים ב {last4}",
  "Confirmed!": "ההזמנה בוצעה בהצלחה",
  "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.":
    "תודה על ביצוע ההזמנה. ברגעים אלה נשלח אישור לכתובת {email}. נתראה בקרוב!",
  "Payment method": "שיטת תשלום",
  "Phone (optional)": "מספר טלפון (אופציונלי)",
  "Please enter at least one attendee.": "אנא הזן לפחות משתתף אחד.",
  "Invite Attendees": "הזמנת משתתפים",
  Message: "הודעה אישית",
  Name: "שם מלא",
  "e.g. Looking forward to seeing you at {offeringName}!":
    "לדוגמא: מחכים לראותכם ב{offeringName}!",
  "Add your attendees below. Their invitation email automatically includes the location, address, and directions.":
    'הוסיפו את המשתתפים למטה. ההזמנה בדוא"ל שלהם כוללת באופן אוטומטי את המיקום, הכתובת והנחיות ההגעה.',
  "View Invitation": "צפה בהזמנה",
  "Will there be others joining you?": "האם יצטרפו אליך משתתפים נוספים?",
  "The invitation email automatically includes the location, address, and directions.":
    'ההזמנה בדוא"ל כוללת באופן אוטומטי את המיקום, הכתובת והנחיות ההגעה.',
  attendee: "משתתף",
  attendees: "משתתפים",
  "Please add email": "אנא הוסף מייל",
  "Please add name": "אנא הוסף שם",
  "Invitation sent!": "הזמנה נשלחה!",
  "An email invitation have been sent to your attendees with details and directions.":
    'נשלחה הזמנה בדוא"ל למשתתפים שלך עם פרטים והנחיות.',
  Attendees: "משתתפים",
  "Attendees:": "מס' אנשים:",
  Done: "בוצע",
  "Invitation sent to 1 attendee": "ההזמנה נשלחה אל משתתף אחד",
  "Invitation sent to {number of attendees} attendees":
    "ההזמנה נשלחה אל {number of attendees} משתתפים",
  "{number of hours}": "{number of hours}",
  "{number of entries}": "{number of entries}",
  "{number of days}": "{number of days}",
  "Sorry, we couldn’t find anything matching your search.":
    "מצטערים, לא הצלחנו למצוא משהו שמתאים לחיפוש שלך.",
  "Reset Filter": "איפוס מסננים",
  "Select a location": "בחר מיקום",
  "Select quantity": "בחר כמות",
  "Select number of guests": "בחר מספר אורחים",
  "Please select the number of guests": "אנא בחר מספר אורחים",
  "Select # of entries": "כמות גישות יומיות",
  "{productTypeName} at {locationName}": "{productTypeName} ב{locationName}",
  "{productTypeName} to {locationName}": "{productTypeName} ל-{locationName}",
  Capacity: "קיבולת",
  "Capacity:": "קיבולת:",
  "Image for illustration purpose only": "התמונה להמחשה בלבד",
  "Send Invitations": "להזמנת המשתתפים",
  ILS: "ש״ח",
  "on {cancelledAt}.": "ב-{cancelledAt}.",
  "Order cancelled": "ההזמנה בוטלה",
  "Cancelled and refunded ": "ההזמנה בוטלה והתקבל החזר ",
  "Cancel Order": "ביטול הזמנה",
  "Cancel available in {time}": "ניתן לבטל בעוד {time}",
  "Cancel temporarily unavailable while invoice is processing":
    "ביטול אינו זמין באופן זמני בזמן עיבוד החשבונית",
  "Finalizing the invoice with your space provider. Cancellation will be available shortly.":
    "מסיימים את החשבונית עם ספק החלל. הביטול יהיה זמין בקרוב.",
  "Cancellation temporarily unavailable, available in approximately {minutes} minutes":
    "ביטול אינו זמין באופן זמני, יהיה זמין בעוד כ-{minutes} דקות",
  "Cancellation now available": "הביטול זמין כעת",
  Cancellation: "ביטול הזמנה",
  "Are you sure you want to cancel and get a refund? This cannot be un-done.":
    "האם אתם בטוחים שברצונכם לבטל את ההזמנה ולקבל החזר? לא ניתן לבטל פעולה זו.",
  "No, do not cancel": "שמירת ההזמנה",
  "Yes, Cancel & Refund": "ביטול הזמנה וקבלת החזר",
  "Or call us at:": "או התקשר אלינו ל:",
  "Additional Products": "מוצרים נוספים",
  "Book now": "להזמין עכשיו",
  "Coming Soon": "בקרוב",
  "Manage bookings": "ניהול הזמנות",
  "Learn more": "למד עוד",
  Daily: "יום יומי",
  "1 Daily Pass": "גישה יומית חד פעמית",
  "Unlimited access": "גישה ללא הגבלה",
  Hourly: "מדי שעה",
  Confirm: "אישור",
  "Start from": "החל מ-",
  "There are no offices available for the selected capacity.":
    "אין משרדים זמינים לתפוסה הנבחרת.",
  Date: "מועד",
  Clear: "ברור",
  "Our Customers Say": "הלקוחות שלנו אומרים",
  "Review from Google": "ביקורת מגוגל",
  phoneNumberOptional: "מספר טלפון (אופציונלי)",
  "Please add your first name": "אנא הוסף את שמך הפרטי",
  "Please add your last name": "אנא הוסף את שם המשפחה שלך",
  "Please enter a valid email": "נא להזין אימייל חוקי",
  "Please enter a valid phone number": "בבקשה הכנס מספר טלפון תקין",
  "Please enter credit card info": "נא להזין פרטי כרטיס אשראי",
  "Please select a location": "אנא בחר מיקום",
  "Message can't be blank": "ההודעה לא יכולה להיות ריקה",
  "Please select quantity": "נא לבחור כמות",
  "Minimum duration": "משך זמן מינימלי",
  "Minimum {count}": "מינימום {count}",
  "Minimum {count} per day": "מינימום {count} ליום",
  "Minimum {count} per day, based on guest count":
    "מינימום {count} ליום, בהתאם למספר האורחים",
  "Minimum {count} per booking": "מינימום {count} להזמנה",
  "Items per day": "פריטים ליום",
  "Items per booking": "פריטים להזמנה",
  "From {price}/day (min {count}/day)":
    "החל מ-{price}/יום (מינימום {count}/יום)",
  "{perDay}/day × {days} · {total}": "{perDay}/יום × {days} · {total}",
  "{perDay}/day": "{perDay}/יום",
  "{qty} per day × {days} = {items}": "{qty} ליום × {days} = {items}",
  "Select at least one day": "בחרו לפחות יום אחד",
  each: "ליחידה",
  "Add to booking · {total}": "הוספה להזמנה · {total}",
  "Update booking · {total}": "עדכון הזמנה · {total}",
  "{count} is the minimum per day. Use Remove from booking if you don't want {name}.":
    "{count} הוא המינימום ליום. השתמשו ב-Remove from booking אם אינכם רוצים {name}.",
  "{count} is the minimum per booking. Use Remove from booking if you don't want {name}.":
    "{count} הוא המינימום להזמנה. השתמשו ב-Remove from booking אם אינכם רוצים {name}.",
  bookingReasonTitle: "מהי מטרת ההזמנה שלך",
  bookingReasonTitleOptional: "ספר לנו עוד על ההזמנה שלך (אופציונלי)",
  specialInstructionsTitle: "הוראות מיוחדות (אופציונלי)",
  specialInstructionsDisplayTitle: "הוראות מיוחדות",
  "E.g Catering, Beverages or equipment": "למשל: קייטרינג, משקאות או ציוד",
  missingBookingReasonError: "אנא הוסף את מטרת ההזמנה שלך",
  bookingReason: "סיבת ההזמנה",
  selectADate: "בחרו תאריך",
  "More to explore...": "עוד לחקור...",
  backTo: "בחזרה ל",
  showFewerAmenities: "הצג פחות שירותים",
  showAllAmenities: "הצג את כל השירותים",
  "Show less": "הצג פחות",
  needHelp: "זקוק לעזרה?",
  Home: "בית",
  Guest: "אוֹרֵחַ",
  Guests: "אורחים",
  copy: "עותק",
  copied: "מוּעֲתָק",
  generalInformation: "מידע כללי",
  "Single pass": "מעבר יחיד",
  "Select capacity": "בחר קיבולת",
  "Enter a code": "הזן קוד",
  Update: "עדכון",
  "Update booking details": "עדכן את פרטי ההזמנה",
  "Select booking details": "בחר פרטי הזמנה",
  "Book this space": "הזמינו מקום זה",
  "Check availability": "בדוק זמינות",
  "Select date": "בחר תאריך",
  "No start dates are available": "אין תאריכי התחלה זמינים",
  "Every date in this membership's start date window is closed or unavailable. Please contact us to arrange a start date.":
    "כל התאריכים בחלון תאריכי ההתחלה של מנוי זה סגורים או לא זמינים. צור קשר כדי לתאם תאריך התחלה.",
  City: "עִיר",
  "Book here": "הזמינו כאן",
  "Select a city": "בחר עיר",
  "Select a country": "בחר ארץ",
  somethingWentWrong: "משהו השתבש",
  availabilityFetchingError:
    "איננו יכולים לבדוק חדרים פנויים כרגע, אנא נסה שוב מאוחר יותר.",
  "Cancellation policy": "מדיניות ביטול",
  "{percent}% refund if cancelled {duration} before booking":
    "{percent}% החזר כספי אם בוטל {duration} לפני ההזמנה",
  "{percent}% refund if cancelled by {time} the day before your booking":
    "{percent}% החזר כספי אם בוטל עד {time} ביום שלפני ההזמנה",
  "Payment information": "פרטי תשלום",
  "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.":
    "תודה לך {firstName}, אנו נחזור אליך בהקדם האפשרי ונשיב לדואל שלך בכתובת {email}.",
  "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ":
    "על ידי מסירת פרטי הכרטיס שלך, אתה מאפשר ל-{partnerName} לחייב את הכרטיס שלך עבור תשלומים עתידיים בהתאם לתשלומים שלהם",
  "Terms of Service": "תנאי השירות",
  Accessibility: "נגישות",
  priceInfoMessage: "המחיר מבוסס על זמינות",
  priceInfoMessageV2: "המחיר משתנה בהתאם לזמינות.",
  priceChargedMessage: "לא תחויבו בשלב זה.",
  from: "מ",
  From: "מ",
  "Already have a reservation": "האם קיימת הזמנה?",
  Yes: "כן",
  No: "לא",
  "We’ve chosen the best possible price for you based on your selections":
    "בחרנו את המחיר הטוב ביותר עבורך על סמך הבחירות שלך",
  "Available spaces": "חדרי ישיבות נוספים",
  "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30":
    "חדרים נוספים אשר יכולים לעניין אתכם הזמינים בשעות הפעילות - 09:00-17:30.",
  "Discounts subject to date availability": "הנחות בכפוף לזמינות בתאריכים",
  "Discount subject to date availability and for meeting rooms only":
    "הנחה בכפוף לזמינות בתאריכים ולחדרי ישיבות בלבד",
  "Book {numberOfHours}+ hours, save {savingValue} on select dates":
    "הזמן {numberOfHours} שעות ומעלה, חסוך {savingValue} בתאריכים נבחרים",
  or: "אוֹ",
  "before VAT": "לפני מע״מ",
  "before VAT per day": "ליום לפני מע״מ",
  "before VAT per hour": "לשעה לפני מע״מ",
  "Additional Spaces": "חללים נוספים",
  "Here are some additional spaces you might be interested in.":
    ".הנה כמה חללים נוספים שאולי יעניינו אותך",
  "Book {numberOfHours}+ hours to unlock {savingDisplay} off.":
    "הזמן {numberOfHours}+ שעות כדי לבטל את הנעילה של {savingDisplay} הנחה.",
  "Additional fees": "עמלות נוספות",
  "varies by layout": "משתנה לפי פריסה",
  "Special instructions": "הנחיות מיוחדות",
  "You're saving {price}": "אתה חוסך {price}",
  Hours: "שעות",
  Mon: "יוֹם שֵׁנִי",
  Tue: "יוֹם שְׁלִישִׁי",
  Wed: "יוֹם רְבִיעִי",
  Thu: "יוֹם חֲמִישִׁי",
  Fri: "יוֹם שִׁישִׁי",
  Sat: "שַׁבָּת",
  Sun: "יוֹם רִאשׁוֹן",
  AM: "בבוקר",
  PM: "בערב",
  "Clear filters": "נקה מסננים",
  "Need more flexibility? Discover the benefits of memberships today!":
    "צריכים יותר שיניון? גלגלו על תוצאות המנויים שלנו כעת!",
  "See details": "צפה בפרטים",
  Where: "אֵיפֹה",
  Anywhere: "בְּכָל מָקוֹם",
  "{numberOfCities} cities, {numberOfBuildings} buildings":
    "{numberOfCities} ערים, {numberOfBuildings} בניינים",
  "{numberOfStates} states, {numberOfBuildings} buildings":
    "{numberOfStates} מדינות, {numberOfBuildings} בניינים",
  "Clear selection": "נקה בחירה",
  "Clear search": "נקה חיפוש",
  'No locations match "{query}"': 'אף מיקום אינו תואם ל-"{query}"',
  "See results": "ראה תוצאות",
  "Search for a city": "חפש עיר",
  "Search for a state": "חפש מדינה",
  Neighborhood: "שכונה",
  "Select a neighborhood": "בחר שכונה",
  "Search for a neighborhood": "חפש שכונה",
  "{numberOfNeighborhoods} neighborhoods, {numberOfBuildings} buildings":
    "{numberOfNeighborhoods} שכונות, {numberOfBuildings} בניינים",
  "Similar meeting rooms available for a larger number of guests":
    "חדרי ישיבות דומים זמינים למספר גדול יותר של אורחים",
  "Similar spaces available for a larger number of guests":
    "חללים דומים זמינים למספר גדול יותר של אורחים",
  "Similar spaces available at other times": "חללים דומים זמינים בזמנים אחרים",
  "Similar spaces available in nearby locations":
    "חללים דומים זמינים במקומות סמוכים",
  "Similar meeting rooms available at other times":
    "חדרי ישיבות דומים זמינים בזמנים אחרים",
  "Similar meeting rooms available in nearby locations":
    "חדרי ישיבות דומים זמינים במקומות סמוכים",
  "Other meeting rooms at {locationName}": "חדרי ישיבות נוספים ב{locationName}",
  "Other meeting rooms available at the same time":
    "חדרי ישיבות נוספים זמינים באותו זמן",
  "Looks like there aren’t any exact matches.": "נראה שאין התאמות מדויקות.",
  "Consider adjusting your filters or browsing similar spaces below.":
    "שקול להתאים את המסננים שלך או לגלוש במקומות דומים למטה.",
  "The dates you selected may be unavailable at this location. Try different dates or clear the date filter.":
    "ייתכן שהתאריכים שבחרת אינם זמינים במיקום זה. נסו תאריכים אחרים או נקו את מסנן התאריך.",
  "Clear locations": "ברור מיקומים",
  "Clear number of guests": "מספר אורחים ברור",
  "Clear date": "תאריך ברור",
  "See all": "ראה הכל",
  "Show more": "הצג עוד",
  "Book {numberOfHours}+ hours, save {savingDisplay}":
    "הזמן {numberOfHours}+ שעות, חסוך {savingDisplay}",
  "Not ready for a membership? Try our workspaces for a day":
    "לא מוכנים למנוי? תכירו את חללים שלנו למשך יום",
  "Best value": "התמורה הטובה ביותר",
  "Prices vary by day. Select a date to choose a time.":
    "המחירים משתנים לפי יום. בחר תאריך לבחירת שעה.",
  Duration: "משך זמן",
  "{numberOfHours} hrs": "{numberOfHours} שעות",
  "{numberOfMinutes} mins": "{numberOfMinutes} דקות",
  "You're saving {savingDisplay}!": "אתה חוסך {savingDisplay}!",
  "loading...": "טְעִינָה...",
  "Continue with Payment": "המשך עם תשלום",
  "After the initial month, you'll be billed {amount}/month on or about the first of the month.":
    "לאחר החודש הראשוני, תחויב בסכום של {amount}/חודש בראשון לחודש או בערך.",
  "{percent}% off for your whole membership": "{percent}% הנחה לכל תקופת המנוי",
  "Discounted price for your whole membership": "מחיר מוזל לכל תקופת המנוי",
  "Promo code copied to clipboard!": "קוד ההטבה הועתק ללוח!",
  "Thank you for signing up!": "תודה שנרשמת!",
  "Your {savingDisplay} off code is": "קוד {savingDisplay} הנחה שלך הוא",
  "Your promotion code will be applied automatically at checkout.":
    "קוד הקידום שלך יוחל אוטומטית בקופה.",
  "Please provide a valid email.": "אנא ספק אימייל חוקי.",
  "Not now": "לא עכשיו",
  "Daily rate includes {bookable_start_time} - {bookable_end_time} access":
    "תעריף יומי כולל גישה בין {bookable_start_time} ל-{bookable_end_time}",
  "Get {savingDisplay} off your next order!":
    "קבלו {savingDisplay} הנחה על ההזמנה הבאה שלכם!",
  "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!":
    "הירשמו כדי לקבל מבצעים והנחות בלעדיות, וקבלו {savingDisplay} הנחה על ההזמנה הבאה שלכם!",
  "Sign up": "הירשם",
  "By signing up, you agree to receive emails related to your discount. One discount per customer/email. Not combinable with other offers.":
    "בהרשמה, אתה מסכים לקבל אימיילים הקשורים להנחה שלך. הנחה אחת ללקוח/מייל. לא ניתן לשילוב עם הצעות אחרות.",
  "{savingDisplay} off applied at checkout": "{savingDisplay} הנחה מוחל בקופה",
  "Get {savingDisplay} Off!": "קבלו {savingDisplay} הנחה!",
  "Your promo code has been applied!": "קוד ההטבה שלך הוחל!",
  "Checking available start times...": "בודק זמני התחלה זמינים...",
  "No available start times for this date.": "אין זמני התחלה זמינים בתאריך זה.",
  "We'll show rooms that fit": "נראה חדרים שמתאימים",
  "and more spacious options if available.":
    "וחדרים נוספים עם מקום יותר אם זמינים.",
  "{count}+ people": "{count}+ אנשים",
  "event spaces": "חללי אירועים",
  "Contact us": "צור קשר",
  "For larger groups, explore our":
    "עבור קבוצות גדולות יותר, גלגלו את חללים שלנו",
  "for larger groups": "עבור קבוצות גדולות יותר",
  Who: "מי",
  "Any number of people": "כל מספר אנשים",
  "contact us": "צור קשר",
  "Enter the minimum or expected number of people":
    "הזן את המספר המינימלי או המשוערך של אנשים",
  "Choose a city or location first to allow date and time filtering":
    "בחר עיר או מיקום תחילה כדי לאפשר סינון לפי תאריך ושעה",
  "Clear start time": "נקה שעת התחלה",
  "Clear duration": "נקה משך זמן",
  "Select a location to filter by date": "בחר מיקום לסינון לפי תאריך",
  "Checkout session expired": "סיום פרוייקט תשלום",
  "Your checkout session has expired. Please refresh your page.":
    "סיום פרוייקט תשלום. אנא הזן שוב כדי להמשיך.",
  "Refresh Page": "רענן דף",
  "Order is being disputed": "ההזמנה נתונה במחלוקת",
  "Order was disputed": "ההזמנה שנויה במחלוקת",
  "Please add your membership number": "אנא הוסף את מספר החברות שלך",
  "Please enter only ten digits": "נא להזין רק עשר ספרות",
  "Membership details": "פרטי חברות",
  "Member ID Barcode": "קוד תיק חברות",
  "Confirm and Join Now": "אישור והצטרפות עכשיו",
  "Meeting rooms": "חדרי ישיבות",
  "Event spaces": "חללי אירועים",
  "Daily offices": "משרדי יום יומיים",
  Category: "קטגוריה",
  optional: "אופציונלי",
  "Confirm and subscribe": "אישור והירשמות",
  "I agree to the terms of service": "אני מסכים לתנאי השירות",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to book, not a guaranteed reservation. You will receive a confirmation email at {email} once your booking is approved.":
    "תודה שבקשתם. אנו נבדק את הפרטים ונאשר את הזמינות בהקדם האפשרי. זוהי בקשה להזמנה, לא תשלום מובטח. תקבלו דואר אלקטרוני של וידוא בכתובת {email} עם האישור של ההזמנה בהקדם האפשרי.",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to subscribe, not a guaranteed subscription. You will receive a confirmation email at {email} once your subscription is approved.":
    "תודה שבקשתם. אנו נבדק את הפרטים ונאשר את הזמינות בהקדם האפשרי. זוהי בקשה להרשמה, לא הרשמה מובטחת. תקבלו דואר אלקטרוני של וידוא בכתובת {email} עם האישור של ההרשמה בהקדם האפשרי.",
  "Request Submitted!": "בקשה נשלחה!",
  // Amenity management (English-only for v1; translations to follow)
  "Add amenity": "Add amenity",
  "Edit amenity": "Edit amenity",
  "Edit description": "Edit description",
  "Remove from library": "Remove from library",
  "Remove from library?": "Remove from library?",
  "Removing…": "Removing…",
  Remove: "Remove",
  "Adding…": "Adding…",
  "Saving…": "Saving…",
  Add: "Add",
  "1. Pick an icon": "1. Pick an icon",
  "2. Describe it": "2. Describe it",
  "Search icons": "Search icons",
  "Search your library": "Search your library",
  "How would you describe this for customers?":
    "How would you describe this for customers?",
  "Aim for 25 characters or fewer so the label fits on one line.":
    "Aim for 25 characters or fewer so the label fits on one line.",
  "Over 25 characters — the label may wrap on desktop. Consider trimming.":
    "Over 25 characters — the label may wrap on desktop. Consider trimming.",
  "Over 40 characters — the label will wrap on every screen. Trim it down.":
    "Over 40 characters — the label will wrap on every screen. Trim it down.",
  Description: "Description",
  "Amenity added to your library.": "Amenity added to your library.",
  "Could not add amenity. Please try again.":
    "Could not add amenity. Please try again.",
  "Amenity updated.": "Amenity updated.",
  "Could not update amenity. Please try again.":
    "Could not update amenity. Please try again.",
  "No icons match your search.": "No icons match your search.",
  "Don't see what you need?": "Don't see what you need?",
  "Add to your library.": "Add to your library.",
  added: "added",
  "Amenity attached.": "Amenity attached.",
  "Could not attach. Please try again.": "Could not attach. Please try again.",
  "Your amenity library is empty. Add one to get started.":
    "Your amenity library is empty. Add one to get started.",
  "Add to your library": "Add to your library",
  "Build your amenity library": "Build your amenity library",
  "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.":
    "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.",
  "Pick from our icon catalog and describe each amenity in your own words.":
    "Pick from our icon catalog and describe each amenity in your own words.",
  "This change is visible to guests immediately.":
    "This change is visible to guests immediately.",
  "Could not save the new order.": "Could not save the new order.",
  "Amenity removed.": "Amenity removed.",
  "Could not remove. Please try again.": "Could not remove. Please try again.",
  "Could not detach amenity (missing identifier).":
    "Could not detach amenity (missing identifier).",
  "Could not detach.": "Could not detach.",
  "Could not detach amenity.": "Could not detach amenity.",
  "No location amenities added yet.": "No location amenities added yet.",
  Catalogs: "Catalogs",
  Catalog: "Catalog",
  "No catalogs yet": "No catalogs yet",
  "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.":
    "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.",
  "1 offering": "1 offering",
  "Catalog not found": "Catalog not found",
  "This catalog isn't available. It may have been renamed or removed.":
    "This catalog isn't available. It may have been renamed or removed.",
  "Back to Catalogs": "Back to Catalogs",
  "Your profile": "Your profile",
  "Follow us on LinkedIn": "עקבו אחרינו בלינקדאין",
  Partner: "Partner",
  "Account type": "Account type",
  "White-label": "White-label",
  Teams: "Teams",
  "1 location": "1 location",
  "Sign out": "Sign out",
  "Your account": "Your account",
  Cancel: "ביטול",
  Edit: "עריכה",
  "Save changes": "שמירת שינויים",
  "Profile updated.": "הפרופיל עודכן.",
  "Your full name": "השם המלא שלך",
  "Please enter your name.": "יש להזין את שמך.",
  "Couldn't save your changes. Please try again.":
    "לא ניתן היה לשמור את השינויים. נסה שוב.",
  "Unavailable on {days} — the add-on will skip that day.":
    "לא זמין ב-{days} — התוספת תדלג על יום זה.",
  "Unavailable on {days} — the add-on will skip those days.":
    "לא זמין ב-{days} — התוספת תדלג על הימים הללו.",
  "Removed {addOns} — no longer available for your booking.":
    "{addOns} הוסר — לא זמין יותר להזמנה שלך.",
  "Removed {addOns} — sold out for your booking.":
    "{addOns} הוסר — אזל המלאי להזמנה שלך.",
  "Removed {addOns} — sold out on {date}.":
    "{addOns} הוסר — אזל המלאי בתאריך {date}.",
  "Removed {addOns} — sold out for a party of {guests} on {date}.":
    "{addOns} הוסר — אזל המלאי לקבוצה של {guests} בתאריך {date}.",
  "Fully booked on {days} — the add-on will skip that day.":
    "אזל המלאי ב-{days} — התוספת תדלג על יום זה.",
  "Fully booked on {days} — the add-on will skip those days.":
    "אזל המלאי ב-{days} — התוספת תדלג על הימים הללו.",
  "Only {count} left": "נותרו {count} בלבד",
  Team: "צוות",
  Role: "תפקיד",
  Admin: "מנהל",
  Standard: "רגיל",
  Actions: "פעולות",
  "Add user": "הוספת משתמש",
  "Remove user": "הסרת משתמש",
  Member: "חבר",
  member: "חבר",
  members: "חברים",
  admin: "מנהל",
  admins: "מנהלים",
  "Team actions for {member}": "פעולות צוות עבור {member}",
  "(you)": "(את/ה)",
  "{email} · (you)": "{email} · (את/ה)",
  "Reset password": "איפוס סיסמה",
  "Send invite": "שליחת הזמנה",
  "Send reset email": "שליחת מייל איפוס",
  "Sending…": "שולח…",
  "Try again": "נסו שוב",
  "We couldn't load our payment provider":
    "לא הצלחנו לטעון את ספק התשלומים שלנו",
  "An ad blocker, privacy extension, or restricted network can block it. Allow this page, or try a different browser.":
    "חוסם פרסומות, תוסף פרטיות או רשת מוגבלת יכולים לחסום אותו. אפשרו את הדף הזה, או נסו דפדפן אחר.",
  "If the payment form doesn't appear, close this window and start your booking again.":
    "אם טופס התשלום לא מופיע, נא לסגור את החלון הזה ולהתחיל את ההזמנה מחדש.",
  "Please add their name.": "נא להזין שם.",
  "Please add a valid email.": "נא להזין כתובת מייל תקינה.",
  "Invite sent to {email}": "הזמנה נשלחה אל {email}",
  "Role updated.": "התפקיד עודכן.",
  "User removed.": "המשתמש הוסר.",
  "Password reset email sent.": "מייל לאיפוס סיסמה נשלח.",
  "Something went wrong. Please try again.": "משהו השתבש. נסו שוב.",
  "Remove {name}": "להסיר את {name}",
  "{count} {name}": "{count} {name}",
  "Remove {name}?": "להסיר את {name}?",
  "Remove this user?": "להסיר את המשתמש הזה?",
  "This removes their access to this dashboard. Their account is kept and they can be re-added later.":
    "פעולה זו מסירה את הגישה שלהם ללוח הבקרה. החשבון נשמר וניתן להוסיף אותם שוב מאוחר יותר.",
  "You're removing yourself — you'll lose access immediately.":
    "אתם מסירים את עצמכם — הגישה תאבד מיד.",
  "Send a password reset email to {email}?":
    "לשלוח מייל לאיפוס סיסמה אל {email}?",
  "Change role to Admin": "שינוי תפקיד למנהל",
  "Change role to Standard": "שינוי תפקיד לרגיל",
  "Send password reset": "שליחת איפוס סיסמה",
  "Full dashboard access, except the Settings section.":
    "גישה מלאה ללוח הבקרה, מלבד מדור ההגדרות.",
  "Everything a standard user can do, plus Settings — notifications and team management.":
    "כל מה שמשתמש רגיל יכול לעשות, ובנוסף הגדרות: התראות וניהול הצוות.",
  "They'll receive an email invitation to set their password.":
    "הם יקבלו מייל הזמנה להגדרת סיסמה.",
  "Manage who can access the {partnerName} dashboard.":
    "נהלו מי יכול לגשת ללוח הבקרה של {partnerName}.",
  "No team members yet": "אין עדיין חברי צוות",
  "Add a team member to give them access to this dashboard.":
    "הוסיפו חבר צוות כדי לתת לו גישה ללוח הבקרה הזה.",
  Settings: "הגדרות",
  "Admin access required": "נדרשת הרשאת מנהל",
  "You need an admin role to manage this team. Ask one of your admins to update your role.":
    "כדי לנהל את הצוות הזה נדרש תפקיד מנהל. בקשו מאחד המנהלים לעדכן את התפקיד שלכם.",
  "You need an admin role to view this page. Ask one of your admins to update your role.":
    "כדי לצפות בדף הזה נדרש תפקיד מנהל. בקשו מאחד המנהלים לעדכן את התפקיד שלכם.",
  "We couldn't load these rooms.": "לא הצלחנו לטעון את החדרים האלה.",
  "We couldn't load your team. Check your connection and try again.":
    "לא הצלחנו לטעון את הצוות. בדקו את החיבור ונסו שוב.",
  "Updating…": "מעדכן…",
  "A booking made inside this window gets its reminder as soon as it's confirmed.":
    "הזמנה שבוצעה בתוך חלון הזמן הזה תקבל את התזכורת מיד עם האישור.",
  "A nudge before the reservation starts. Because it's built at send time, anything time-sensitive you put here — an access code, say — is always the version you last saved.":
    "תזכורת לפני תחילת ההזמנה. מכיוון שהיא נבנית בזמן השליחה, כל תוכן רגיש לזמן שתוסיף כאן — קוד גישה, למשל — תמיד יהיה בגרסה האחרונה ששמרת.",
  "Add product type": "הוסף סוג מוצר",
  "Add teammate": "הוסף חבר צוות",
  "All changes saved": "כל השינויים נשמרו",
  "All locations": "כל המיקומים",
  "All notifications": "כל ההתראות",
  "Also send a copy to your team": "שלח עותק גם לצוות שלך",
  "An invitation to buy another multi-pass, sent when a customer runs out. Turn it off if you run your own re-engagement emails — from HubSpot, for example.":
    "הזמנה לרכישת מולטי-פס נוסף, שנשלחת כשהמולטי-פס של הלקוח נגמר. כבה אותה אם אתה שולח מיילים משלך להחזרת לקוחות — מ-HubSpot, למשל.",
  "Applies to": "חל על",
  "Automated emails Flexspace sends your customers. Open one to change what it says, when it goes out, or turn it off.":
    "מיילים אוטומטיים ש-Flexspace שולחת ללקוחות שלך. פתח אחד כדי לשנות מה כתוב בו, מתי הוא נשלח, או לכבות אותו.",
  "Before the booking starts": "לפני תחילת ההזמנה",
  "Booking reminder": "תזכורת הזמנה",
  "Booking reminder saved.": "תזכורת ההזמנה נשמרה.",
  CC: "עותק",
  Custom: "מותאם",
  Default: "ברירת מחדל",
  "Every booking": "כל הזמנה",
  "Every confirmed booking gets this reminder.":
    "כל הזמנה מאושרת מקבלת את התזכורת הזו.",
  "Flexspace writes and sends this email — the exact copy is shown in the preview. Editing the wording here is coming; for now you can turn it off or CC your team.":
    "Flexspace כותבת ושולחת את המייל הזה — הנוסח המדויק מוצג בתצוגה המקדימה. עריכת הנוסח כאן תגיע בהמשך; בינתיים אפשר לכבות אותו או לצרף את הצוות בעותק.",
  Insert: "הוסף",
  "Leave this on your default and it follows every change you make there. A space here can still send its own on top.":
    "אם תשאיר את ברירת המחדל, היא תשתנה יחד עם כל שינוי שתעשה שם. חלל כאן עדיין יכול לשלוח גרסה משלו.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, 9:00 AM.":
    "השדות הדינמיים מוצגים ממולאים בהזמנה לדוגמה: Priya Raman, Studio 2 ב-Mission Bay, 9:00.",
  "Mission Bay": "Mission Bay",
  "Multi Day Pass 5 Pack": "Multi Day Pass 5 Pack",
  "Multi-pass top-up": "חידוש מולטי-פס",
  "Multi-pass top-up saved.": "חידוש המולטי-פס נשמר.",
  "No one CC'd": "אף אחד לא בעותק",
  "No product types match": "אין סוגי מוצר שתואמים את",
  "No reminder goes out until you set one up.":
    "לא נשלחת שום תזכורת עד שתגדיר אחת.",
  "Not set": "לא הוגדר",
  Notifications: "התראות",
  Off: "כבוי",
  "Off sends nothing here, whatever the levels above say.":
    "כשזה כבוי לא נשלח כאן דבר, מה שלא יגידו הרמות שמעל.",
  "Off stops the reminder everywhere.": "כשזה כבוי התזכורת נעצרת בכל מקום.",
  On: "פעיל",
  "Only bookings of certain product types": "רק הזמנות מסוגי מוצר מסוימים",
  "Only bookings of the selected product types get this reminder.":
    "רק הזמנות מסוגי המוצר שנבחרו מקבלות את התזכורת הזו.",
  Override: "התאמה",
  "Payment failed": "התשלום נכשל",
  'Pick at least one product type, or switch back to "Every booking".':
    'בחר לפחות סוג מוצר אחד, או חזור ל"כל הזמנה".',
  Preview: "תצוגה מקדימה",
  "Rebuilt at send time — edits reach every future email":
    "נבנה מחדש בזמן השליחה — עריכות מגיעות לכל מייל עתידי",
  Reminder: "תזכורת",
  "Reminder email": "אימייל תזכורת",
  "Reminder reset — this level inherits again.":
    "התזכורת אופסה — הרמה הזו חוזרת לירושה.",
  "Reminders cascade: your default applies everywhere. A location can send its own, and a space can send its own on top of that.":
    "התזכורות נגזרות בשרשרת: ברירת המחדל שלך חלה בכל מקום. מיקום יכול לשלוח גרסה משלו, וחלל יכול לשלוח גרסה משלו מעל זה.",
  "Remove override": "הסר את ההתאמה",
  "Reset to defaults": "איפוס לברירת המחדל",
  "Sample booking": "הזמנה לדוגמה",
  "Save reminder": "שמירת התזכורת",
  "Search locations": "חיפוש מיקומים",
  "Search product types…": "חפש סוגי מוצר…",
  "Search spaces": "חיפוש חללים",
  "See reminder": "הצגת התזכורת",
  "Sends its own version — every space here inherits it.":
    "שולח גרסה משלו — כל חלל כאן יורש אותה.",
  "Sent the moment the last pass in a bundle is used — timing can't be changed.":
    "נשלח ברגע שהכניסה האחרונה בחבילה מנוצלת — את התזמון לא ניתן לשנות.",
  "Set up reminder": "הגדרת תזכורת",
  "Shown with a sample customer and pass. The wording is what actually goes out; the button and photo take your own branding.":
    "מוצג עם לקוח ומולטי-פס לדוגמה. הנוסח הוא מה שנשלח בפועל; הכפתור והתמונה מקבלים את המיתוג שלך.",
  Space: "חלל",
  "Spaces at": "חללים ב",
  Subject: "נושא",
  "The reminder bookings of this space get, inheriting from its location.":
    "התזכורת שמקבלות ההזמנות של החלל הזה, בירושה מהמיקום שלו.",
  "The reminder every booking at this location gets, inheriting from your default.":
    "התזכורת שמקבלת כל הזמנה במיקום הזה, בירושה מברירת המחדל שלך.",
  "The reminder every booking gets before it starts, unless a location or a space sends its own.":
    "התזכורת שמקבלת כל הזמנה לפני תחילתה, אלא אם מיקום או חלל שולחים גרסה משלהם.",
  "They're CC'd on every copy of this email that goes out.":
    "הם מקבלים עותק מכל מייל כזה שנשלח.",
  "This email is off, so nobody is receiving it. Your settings are saved and will apply if you turn it back on.":
    "המייל הזה כבוי, כך שאיש אינו מקבל אותו. ההגדרות שלך שמורות ויחולו אם תפעיל אותו מחדש.",
  "This is the most specific level: a reminder set here wins over its location and your default.":
    "זו הרמה הספציפית ביותר: תזכורת שנקבעת כאן גוברת על המיקום שלה ועל ברירת המחדל שלך.",
  "This location": "המיקום הזה",
  "This space": "החלל הזה",
  To: "אל",
  "Turn this email on or off": "הפעל או כבה את המייל הזה",
  "Turn this reminder on or off": "הפעלה או כיבוי של התזכורת",
  "Unsaved changes": "שינויים שלא נשמרו",
  Using: "משתמש ב",
  "Using default": "משתמש בברירת המחדל",
  "Using your default — every space here inherits it.":
    "משתמש בברירת המחדל שלך — כל חלל כאן יורש אותה.",
  "We couldn't load your booking reminder. Check your connection and try again.":
    "לא הצלחנו לטעון את תזכורת ההזמנה שלך. בדוק את החיבור ונסה שוב.",
  "We couldn't reset this reminder. Try again.":
    "לא הצלחנו לאפס את התזכורת הזו. נסה שוב.",
  "We couldn't save this reminder. Try again.":
    "לא הצלחנו לשמור את התזכורת הזו. נסה שוב.",
  "What your customers get": "מה הלקוחות שלך מקבלים",
  "When a customer uses their last day pass":
    "כאשר לקוח מנצל את הכניסה היומית האחרונה שלו",
  "When it sends": "מתי הוא נשלח",
  "Yours to configure": "בשליטתך",
  custom: "מותאמים",
  "custom version": "גרסה מותאמת",
  "custom versions": "גרסאות מותאמות",
  "hours before the booking starts": "שעות לפני תחילת ההזמנה",
  location: "מיקום",
  of: "מתוך",
  "reminder settings": "הגדרות התזכורת",
  space: "חלל",
  spaces: "חללים",
  "your default": "ברירת המחדל שלך",
  "Space layouts": "פריסות החלל",
  "See all space layouts": "הצג את כל הפריסות",
  "All space layouts": "כל פריסות החלל",
  Layout: "פריסה",
  "Select layout": "בחר פריסה",
  "Number of people": "מספר אנשים",
  "Our meeting rooms fit up to {max} people.":
    "חדרי הישיבות שלנו מתאימים לעד {max} אנשים.",

  // Staff order confirmation email (Settings -> Notifications)
  "Staff order confirmation": "אישור הזמנה לצוות",
  "When an order is confirmed": "כאשר הזמנה מאושרת",
  "Who on your team hears about a confirmed order, and what they read. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "מי בצוות שלך שומע על הזמנה שאושרה, ומה הוא קורא. הגדירו פעם אחת לכל המקומות, ואז אפשרו למיקום, לסוג מוצר או לחלל בודד להיות שונים היכן שצריך.",
  "Who on your team hears about a confirmed order, and what they read. These apply to every location and space unless a more specific level sets its own.":
    "מי בצוות שלך שומע על הזמנה שאושרה, ומה הוא קורא. חל על כל מיקום וחלל, אלא אם רמה ספציפית יותר מגדירה משלה.",
  "This email cascades: your defaults apply everywhere. A location can set its own, a product type at that location can set its own, and a single space can set its own on top of that.":
    "המייל הזה עובד במדרג: ברירות המחדל שלך חלות בכל מקום. מיקום יכול להגדיר משלו, סוג מוצר במיקום הזה יכול להגדיר משלו, וחלל בודד יכול להגדיר משלו מעל הכול.",
  "The staff email for every order at this location, inheriting from your defaults.":
    "המייל לצוות עבור כל הזמנה במיקום הזה, בירושה מברירות המחדל שלך.",
  "Anything left on its default here follows your defaults. A product type or a single space at":
    "כל מה שנשאר כאן על ברירת המחדל עוקב אחר ברירות המחדל שלך. סוג מוצר או חלל בודד ב־",
  "can still set its own on top.": "עדיין יכולים להגדיר משלהם מעל.",
  "Orders of this product type at this location only, inheriting from the location and your defaults.":
    "רק הזמנות מסוג המוצר הזה במיקום הזה, בירושה מהמיקום ומברירות המחדל שלך.",
  "Anything custom here wins over": "כל הגדרה מותאמת כאן גוברת על",
  "and your defaults. A single space can still set its own on top.":
    "ועל ברירות המחדל שלך. חלל בודד עדיין יכול להגדיר משלו מעל.",
  "This space only, inheriting from everything above it.":
    "רק החלל הזה, בירושה מכל מה שמעליו.",
  "This is the most specific level: anything custom here wins over every other level.":
    "זו הרמה הספציפית ביותר: כל הגדרה מותאמת כאן גוברת על כל רמה אחרת.",
  Recipients: "נמענים",
  Sender: "שולח",
  "Staff instructions": "הנחיות לצוות",
  "Applies to every order unless a more specific level sets its own list. Overriding replaces every recipient — lists don't merge across levels.":
    "חל על כל הזמנה, אלא אם רמה ספציפית יותר מגדירה רשימה משלה. דריסה מחליפה את כל הנמענים — הרשימות אינן מתמזגות בין הרמות.",
  "Overriding replaces the inherited list in full — lists don't merge across levels.":
    "דריסה מחליפה את הרשימה שהתקבלה בירושה במלואה — הרשימות אינן מתמזגות בין הרמות.",
  "We couldn't load this email's settings. Check your connection and try again.":
    "לא הצלחנו לטעון את ההגדרות של המייל הזה. בדקו את החיבור ונסו שוב.",
  "Only an admin can change this email. You can look up any level here.":
    "רק מנהל יכול לשנות את המייל הזה. כאן אפשר לעיין בכל רמה.",
  Defaults: "ברירות מחדל",
  "Product type": "סוג מוצר",
  "Product types at": "סוגי מוצרים ב־",
  "Spaces using this product type": "חללים שמשתמשים בסוג המוצר הזה",
  "Sits between the location and a single space. A meeting room and a day pass at the same address rarely need the same people notified.":
    "יושב בין המיקום לבין חלל בודד. חדר ישיבות וכרטיס יומי באותה כתובת רק לעיתים רחוקות צריכים לעדכן את אותם אנשים.",
  "No product type": "ללא סוג מוצר",
  "No one": "אף אחד",
  "no one": "אף אחד",
  Open: "פתח",
  "Reset all to defaults": "אפס הכול לברירות המחדל",
  "Reset to": "אפס ל־",
  "reset to defaults.": "אופס לברירות המחדל.",
  "Couldn't reset this level. Please try again.":
    "לא הצלחנו לאפס את הרמה הזו. נסו שוב.",
  "Actions for": "פעולות עבור",
  "Using default · from": "משתמש בברירת המחדל · מ־",
  "saved.": "נשמר.",
  "Sent to": "נשלח אל",
  "Everyone here is on the To line. At least one is required.":
    "כל מי שכאן נמצא בשורת הנמענים. נדרש לפחות אחד.",
  "Reply-to": "השב אל",
  "Where a reply lands. Optional — leave it empty and replies go to the From address.":
    "לאן מגיעה תשובה. אופציונלי — השאירו ריק והתשובות יגיעו לכתובת השולח.",
  "From name": "שם השולח",
  "The name your team sees in their inbox.": "השם שהצוות שלך רואה בתיבת הדואר.",
  "Merge fields are filled in when the order is confirmed.":
    "שדות המיזוג ממולאים כאשר ההזמנה מאושרת.",
  Title: "כותרת",
  "The heading inside the email.": "הכותרת בתוך המייל.",
  "Note to your team": "הערה לצוות שלך",
  "Rebuilt at send time, so a change reaches every future order.":
    "נבנה מחדש בזמן השליחה, כך שכל שינוי מגיע לכל הזמנה עתידית.",
  Attachment: "קובץ מצורף",
  "One PDF, sent with every copy of this email.":
    "קובץ PDF אחד, נשלח עם כל עותק של המייל הזה.",
  "Upload PDF": "העלה PDF",
  Replace: "החלף",
  "Uploading…": "מעלה…",
  "Add recipient": "הוסף נמען",
  "Add reply-to": "הוסף השב אל",
  "Add reply-to address": "הוסף כתובת להשבה",
  "Add 1 recipient": "הוסף נמען אחד",
  recipient: "נמען",
  recipients: "נמענים",
  override: "דריסה",
  overrides: "דריסות",
  "Add a recipient to continue.": "הוסיפו נמען כדי להמשיך.",
  "At least one recipient is required, or reset this level so it falls back to":
    "נדרש לפחות נמען אחד, או אפסו את הרמה הזו כדי שתחזור אל",
  "At least one recipient is required — nothing sends without one.":
    "נדרש לפחות נמען אחד — בלעדיו שום דבר לא נשלח.",
  "Anyone here receives the full order details, including the guest's name and email.":
    "כל מי שכאן מקבל את פרטי ההזמנה המלאים, כולל שם האורח והמייל שלו.",
  "Your team": "הצוות שלך",
  "Already added": "כבר נוסף",
  "Someone else": "מישהו אחר",
  Address: "כתובת",
  "is not a valid email address.": "אינה כתובת מייל תקינה.",
  "is already on the list.": "כבר נמצאת ברשימה.",
  "Send test email": "שלח מייל בדיקה",
  "Send test": "שלח בדיקה",
  "Send to": "שלח אל",
  "What will send": "מה יישלח",
  "We'll send one copy of the": "נשלח עותק אחד של הגרסה של",
  "version, filled in with a sample order. Your real recipients are not contacted.":
    ", ממולא בהזמנה לדוגמה. הנמענים האמיתיים שלך אינם מקבלים דבר.",
  "Test sent to": "בדיקה נשלחה אל",
  "Couldn't send the test. Please try again.":
    "לא הצלחנו לשלוח את הבדיקה. נסו שוב.",
  "your defaults": "ברירות המחדל שלך",
  "reset — this level inherits again.": "אופס — הרמה הזו יורשת שוב.",
  "Staff email": "מייל לצוות",
  "See recipients": "הצג נמענים",
  "can still set its own on top — a meeting room and a day pass at the same address rarely need the same people notified.":
    "עדיין יכולים להגדיר משלהם מעל — חדר ישיבות וכרטיס יומי באותה כתובת רק לעיתים רחוקות צריכים לעדכן את אותם אנשים.",
  "Search product types": "חיפוש סוגי מוצרים",
  "product type": "סוג מוצר",
  "Set up": "הגדר",
  "Using defaults": "משתמש בברירות המחדל",
  "Staff order confirmation saved.": "אישור ההזמנה לצוות נשמר.",
  "This product type": "סוג המוצר הזה",
  "No one is notified until you name someone.":
    "אף אחד לא מקבל עדכון עד שתציינו מישהו.",
  "Merge fields are shown filled in with a sample order: Priya Raman, Studio 2 at Mission Bay, July 30.":
    "שדות המיזוג מוצגים ממולאים בהזמנה לדוגמה: Priya Raman, Studio 2 במיקום Mission Bay, 30 ביולי.",
  "One step more specific than this location: applies to orders of that type here, and a single space can still override it.":
    "רמה אחת ספציפית יותר מהמיקום הזה: חלה על הזמנות מהסוג הזה כאן, וחלל בודד עדיין יכול לדרוס אותה.",
  "The most specific level: a space overrides its product type and this location.":
    "הרמה הספציפית ביותר: חלל גובר על סוג המוצר שלו ועל המיקום הזה.",
  "The most specific level: a space overrides this product type and its location.":
    "הרמה הספציפית ביותר: חלל גובר על סוג המוצר הזה ועל המיקום שלו.",
  "This booking link looks incomplete": "קישור ההזמנה נראה חלקי",
  "Some email apps shorten long links. Please open the link from your confirmation email again, or contact the venue if it keeps happening.":
    "חלק מאפליקציות הדוא״ל מקצרות קישורים ארוכים. אנא פתחו שוב את הקישור מהודעת האישור, או פנו לחלל אם התקלה חוזרת.",
  "Guest order confirmation": "אישור הזמנה לאורח",
  "When a customer books": "כשלקוח מזמין",
  "The confirmation every customer gets when they book — the welcome note, directions and help section. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "האישור שכל לקוח מקבל כשהוא מזמין — הודעת הפתיחה, ההכוונה ואזור העזרה. הגדירו פעם אחת לכל מקום, ותנו למיקום, לסוג מוצר או לחלל בודד להיות שונים היכן שצריך.",
  "What your customers read when a booking is confirmed — the subject, the welcome note, directions and help section. These apply everywhere unless a more specific level sets its own. Every confirmed booking sends one: this email can't be turned off.":
    "מה שהלקוחות שלכם קוראים כשהזמנה מאושרת — הנושא, הודעת הפתיחה, ההכוונה ואזור העזרה. חלים בכל מקום אלא אם רמה ספציפית יותר מגדירה משלה. כל הזמנה מאושרת שולחת אחד: אי אפשר לכבות את המייל הזה.",
  "The booking confirmation for every order at this location, inheriting from your defaults.":
    "אישור ההזמנה לכל הזמנה במיקום הזה, יורש מברירות המחדל שלכם.",
  "Anything left on its default here follows your defaults. What you set here also backs this location's add-on and invite confirmation emails. A product type or a single space at":
    "כל מה שנשאר כאן על ברירת המחדל עוקב אחר ברירות המחדל שלכם. מה שתגדירו כאן משמש גם כבסיס למיילי אישור התוספים וההזמנות של המיקום הזה. סוג מוצר או חלל בודד ב-",
  "Bookings of this product type at this location only, inheriting from the location and your defaults.":
    "הזמנות מסוג המוצר הזה במיקום הזה בלבד, יורשות מהמיקום ומברירות המחדל שלכם.",
  "Customer email": "מייל ללקוח",
  "See what sends": "ראו מה נשלח",
  "Guest order confirmation saved.": "אישור ההזמנה לאורח נשמר.",
  "Subject & title": "נושא וכותרת",
  "Email content": "תוכן המייל",
  "Reply-to & attachment": "כתובת למענה וקובץ מצורף",
  "The subject and title can carry:": "הנושא והכותרת יכולים לכלול:",
  "Each section falls back to our standard copy when left empty — the preview shows exactly what sends.":
    "כל אזור חוזר לתוכן הסטנדרטי שלנו כשהוא נשאר ריק — התצוגה המקדימה מציגה בדיוק את מה שנשלח.",
  "Our standard subject": "שורת הנושא הסטנדרטית שלנו",
  "welcome note": "הודעת פתיחה",
  directions: "הכוונה",
  "help section": "אזור העזרה",
  "Every section sends our standard copy.":
    "כל האזורים שולחים את התוכן הסטנדרטי שלנו.",
  "Custom copy:": "תוכן מותאם:",
  "Welcome note": "הודעת פתיחה",
  "Help section": "אזור העזרה",
  "Merge fields fill in when the booking is confirmed. Empty sends our standard subject.":
    "שדות מיזוג מתמלאים כשהזמנה מאושרת. שדה ריק שולח את שורת הנושא הסטנדרטית שלנו.",
  "The headline inside the email. Empty sends our standard headline.":
    "הכותרת בתוך המייל. שדה ריק שולח את הכותרת הסטנדרטית שלנו.",
  "Opens the email, above the booking details. Empty sends our standard thank-you.":
    "פותח את המייל, מעל פרטי ההזמנה. שדה ריק שולח את הודעת התודה הסטנדרטית שלנו.",
  "Under the email's Directions heading, next to the map link. Empty sends the location's address line.":
    "מתחת לכותרת ההכוונה במייל, ליד הקישור למפה. שדה ריק שולח את שורת הכתובת של המיקום.",
  "Closes the email. Empty shows cancellation guidance while the booking can still be cancelled.":
    "סוגר את המייל. שדה ריק מציג הנחיות ביטול כל עוד אפשר לבטל את ההזמנה.",
  "Where a customer's reply lands. Empty sends replies to the From address.":
    "לאן מגיעה תשובת הלקוח. שדה ריק שולח תשובות לכתובת השולח.",
  "The name customers see in their inbox.":
    "השם שהלקוחות רואים בתיבת הדואר שלהם.",
  "One PDF, sent with every confirmation.": "קובץ PDF אחד, נשלח עם כל אישור.",
  "Opening hours": "שעות פתיחה",
  "The location's opening hours are listed here.":
    "כאן מוצגות שעות הפתיחה של המיקום.",
  "Our standard help copy: cancellation guidance shows while the booking can still be cancelled.":
    "טקסט העזרה הסטנדרטי שלנו: הנחיות ביטול מוצגות כל עוד אפשר לבטל את ההזמנה.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, July 30. The preview shows what actually sends — including inherited and standard copy you haven't overridden.":
    "שדות מיזוג מוצגים כשהם מלאים בהזמנה לדוגמה: פריה ראמאן, Studio 2 ב-Mission Bay, 30 ביולי. התצוגה המקדימה מציגה את מה שנשלח בפועל — כולל תוכן מורש וסטנדרטי שלא דרסתם.",
  "If a product type or space overrides this copy for that booking, the email shows the version that actually sent.":
    "אם סוג מוצר או חלל דורסים את התוכן הזה עבור ההזמנה הזו, המייל יציג את הגרסה שנשלחה בפועל.",
  "We'll re-send the confirmation from one of your recent bookings — the real email, exactly as that customer received it. It carries that booking's real details, so send it somewhere you'd be comfortable those details going.":
    "נשלח מחדש את האישור מאחת ההזמנות האחרונות שלכם — המייל האמיתי, בדיוק כפי שאותו לקוח קיבל אותו. הוא מכיל את הפרטים האמיתיים של ההזמנה, לכן שלחו אותו לכתובת שנוח לכם שהפרטים האלה יגיעו אליה.",
  "only the address above": "רק הכתובת שלמעלה",
  // Recurring bookings — the storefront Repeat control
  "These dates are no longer available: {dates}. Choose another time, or turn Repeat off.":
    "התאריכים האלה כבר לא זמינים: {dates}. בחרו שעה אחרת או כבו את החזרה.",
  "Every {weekday}": "כל {weekday}",
  "Every {interval} weeks on {weekday}": "כל {interval} שבועות ביום {weekday}",
  "{span} · {count} bookings": "{span} · {count} הזמנות",
  "Your bookings": "ההזמנות שלכם",
  "{date} fell on your pattern but was already taken. It was left out of the recurring booking and was not charged.":
    "{date} נפל על התבנית שלכם אך כבר היה תפוס. הוא הושמט מההזמנה החוזרת ולא חויב.",
  "{dates} fell on your pattern but were already taken. They were left out of the recurring booking and were not charged.":
    "{dates} נפלו על התבנית שלכם אך כבר היו תפוסים. הם הושמטו מההזמנה החוזרת ולא חויבו.",
  "Thank you for booking with us. A confirmation email covering all {count} bookings has been sent to {email}. We are looking forward to seeing you soon.":
    "תודה שהזמנתם אצלנו. אימייל אישור המכסה את כל {count} ההזמנות נשלח אל {email}. נשמח לראותכם בקרוב.",
  "Not refundable. A single date can be cancelled to free the room, but is not refunded.":
    "ללא החזר. אפשר לבטל תאריך בודד כדי לפנות את החדר, אך הוא לא מוחזר.",
  "Refundable in full until {deadline}. After that, a single date can be cancelled to free the room, but is not refunded.":
    "ניתן להחזר מלא עד {deadline}. לאחר מכן אפשר לבטל תאריך בודד כדי לפנות את החדר, אך הוא לא מוחזר.",
  "Charged once for the whole recurring booking.":
    "נגבה פעם אחת עבור כל ההזמנה החוזרת.",
  "Choose a date and time to repeat this booking.":
    "בחרו תאריך ושעה כדי לחזור על הזמנה זו.",
  "Choose a date to repeat this booking.": "בחרו תאריך כדי לחזור על הזמנה זו.",
  "Repeat this booking": "חזור על הזמנה זו",
  "Same room and time, every week": "אותו חדר ואותה שעה, כל שבוע",
  "Same room and time, every {weekday}": "אותו חדר ואותה שעה, כל יום {weekday}",
  Weekly: "שבועי",
  "Every 2 weeks": "כל שבועיים",
  "Every 3 weeks": "כל 3 שבועות",
  "Every 4 weeks": "כל 4 שבועות",
  "location closed": "המיקום סגור",
  "already booked": "כבר הוזמן",
  "too soon to book": "מוקדם מדי להזמנה",
  "too short for this room": "קצר מדי לחדר זה",
  unavailable: "לא זמין",
  Unavailable: "לא זמין",
  "{count} booking": "{count} הזמנה",
  "{count} bookings": "{count} הזמנות",
  "Shortened to {count} bookings — a recurring booking has to finish inside the booking window, which ends {date}.":
    "קוצר ל-{count} הזמנות — הזמנה חוזרת חייבת להסתיים בתוך חלון ההזמנה, שמסתיים ב-{date}.",
  "{count} bookings · {first} – {last}": "{count} הזמנות · {first} – {last}",
  "Prices confirmed on Save": "המחירים מאושרים בשמירה",
  "{count} unavailable date skipped · prices confirmed on Save":
    "תאריך לא זמין {count} הושמט · המחירים מאושרים בשמירה",
  "{count} unavailable dates skipped · prices confirmed on Save":
    "{count} תאריכים לא זמינים הושמטו · המחירים מאושרים בשמירה",
  "Repeats {preset} · {count} bookings through {last}":
    "חוזר {preset} · {count} הזמנות עד {last}",
  "{first} through {last}": "מ-{first} עד {last}",
  "Every date on this pattern is available.": "כל התאריכים בתבנית זו זמינים.",
  "1 date on this pattern is unavailable and not charged: {list}.":
    "תאריך אחד בתבנית זו אינו זמין ואינו מחויב: {list}.",
  "{count} dates on this pattern are unavailable and not charged: {list}.":
    "{count} תאריכים בתבנית זו אינם זמינים ואינם מחויבים: {list}.",
  "Your recurring booking": "ההזמנה החוזרת שלך",
  // Manage-order page — the customer's own view of a booking
  "This booking could not be loaded. Please try again, or contact the venue.":
    "לא ניתן היה לטעון את ההזמנה. נסו שוב או פנו למקום.",
  "1 guest": "אורח 1",
  "{count} guests": "{count} אורחים",
  "This date could not be cancelled.": "לא ניתן היה לבטל את התאריך הזה.",
  "The booking could not be cancelled.": "לא ניתן היה לבטל את ההזמנה.",
  "This page is for recurring bookings. Your booking is on its confirmation page.":
    "עמוד זה מיועד להזמנות חוזרות. ההזמנה שלך נמצאת בעמוד האישור שלה.",
  "Open confirmation page": "פתיחת עמוד האישור",
  "Cancelled on {date}, before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.":
    "בוטלה ב-{date}, לפני ההזמנה הראשונה. כל אחד מ-{count} התאריכים בוטל ו-{refund} הוחזרו לאמצעי התשלום שלכם.",
  "1 booking cancelled": "הזמנה אחת בוטלה",
  "Confirmation {code}": "אישור {code}",
  "Booked {date}": "הוזמן ב-{date}",
  "Next booking": "ההזמנה הבאה",
  "Your booking": "ההזמנה שלכם",
  "Cancelled recurring booking": "הזמנה חוזרת שבוטלה",
  "Cancelled booking": "הזמנה שבוטלה",
  "No bookings left": "לא נותרו הזמנות",
  "{completed} of {total} bookings completed":
    "{completed} מתוך {total} הזמנות הושלמו",
  "{done} · booking {next} is next": "{done} · הזמנה {next} היא הבאה",
  "Add recurring booking to calendar": "הוספת ההזמנה החוזרת ליומן",
  "Add to calendar": "הוספה ליומן",
  "Get directions": "הוראות הגעה",
  "Book this again": "להזמין שוב",
  "Book this room again": "להזמין את החדר הזה שוב",
  "This recurring booking was cancelled": "ההזמנה החוזרת הזו בוטלה",
  "This booking was cancelled": "ההזמנה הזו בוטלה",
  "Cancelled on {date}. {refund} was refunded to your payment method.":
    "בוטלה ב-{date}. {refund} הוחזרו לאמצעי התשלום שלכם.",
  "Cancelled on {date}. No refund was issued.":
    "בוטלה ב-{date}. לא הונפק החזר כספי.",
  Schedule: "לוח זמנים",
  "{count} bookings cancelled": "{count} הזמנות בוטלו",
  "{completed} completed · {cancelled} cancelled · {upcoming} upcoming":
    "{completed} הושלמו · {cancelled} בוטלו · {upcoming} קרובות",
  Upcoming: "קרובה",
  Completed: "הושלמה",
  Cancelled: "בוטלה",
  "Cancel this date?": "לבטל את התאריך הזה?",
  "{date} will be freed for someone else, and the rest of your recurring booking stays exactly as it is.":
    "{date} יתפנה למישהו אחר, ושאר ההזמנה החוזרת שלכם נשארת בדיוק כפי שהיא.",
  "This date is not refunded. Your total stays {total}.":
    "התאריך הזה לא מוחזר. הסכום הכולל שלכם נשאר {total}.",
  "Cancel this date": "ביטול התאריך הזה",
  "Keep this date": "להשאיר את התאריך הזה",
  "Cancelling this booking": "ביטול ההזמנה הזו",
  "Dates can be cancelled one at a time but are not refunded. This recurring booking is not refundable.":
    "אפשר לבטל תאריכים אחד-אחד, אך הם לא מוחזרים. ההזמנה החוזרת הזו אינה ניתנת להחזר.",
  "Cancel the whole recurring booking for a full refund until {deadline}. After that, dates can be cancelled one at a time but are not refunded.":
    "בטלו את כל ההזמנה החוזרת להחזר מלא עד {deadline}. לאחר מכן אפשר לבטל תאריכים אחד-אחד, אך ללא החזר.",
  "Dates can be cancelled but are not refunded. The recurring booking was refundable in full until {deadline}.":
    "אפשר לבטל תאריכים, אך הם לא מוחזרים. ההזמנה החוזרת הייתה ניתנת להחזר מלא עד {deadline}.",
  "Cancel all upcoming": "ביטול כל התאריכים הקרובים",
  "Cancel booking": "ביטול ההזמנה",
  "Cancel this recurring booking?": "לבטל את ההזמנה החוזרת הזו?",
  "All {count} upcoming dates will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "כל {count} התאריכים הקרובים יבוטלו והחדרים יתפנו. {refund} מוחזרים לאמצעי התשלום שלכם. החזרים מופיעים תוך 5–10 ימי עסקים.",
  "All 1 upcoming date will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "התאריך הקרוב היחיד יבוטל והחדר יתפנה. {refund} מוחזרים לאמצעי התשלום שלכם. החזרים מופיעים תוך 5–10 ימי עסקים.",
  "Cancel and refund": "ביטול והחזר",
  "Keep booking": "להשאיר את ההזמנה",
  "This recurring booking can no longer be refunded":
    "ההזמנה החוזרת הזו כבר לא ניתנת להחזר",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "הזמנה חוזרת ניתנת להחזר מלא עד {deadline}, ומועד זה עבר. עדיין אפשר לבטל את {count} התאריכים הקרובים אחד-אחד, מה שמפנה את החדר באותם תאריכים.",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "הזמנה חוזרת ניתנת להחזר מלא עד {deadline}, ומועד זה עבר. עדיין אפשר לבטל את התאריך הקרוב היחיד, מה שמפנה את החדר באותו תאריך.",
  "This recurring booking is not refundable. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "ההזמנה החוזרת הזו אינה ניתנת להחזר. עדיין אפשר לבטל את {count} התאריכים הקרובים אחד-אחד, מה שמפנה את החדר באותם תאריכים.",
  "This recurring booking is not refundable. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "ההזמנה החוזרת הזו אינה ניתנת להחזר. עדיין אפשר לבטל את התאריך הקרוב היחיד, מה שמפנה את החדר באותו תאריך.",
  "Cancelled dates are not refunded. To ask for an exception, talk with the space directly.":
    "תאריכים שבוטלו אינם מוחזרים. כדי לבקש חריגה, דברו ישירות עם המתחם.",
  "Back to booking": "חזרה להזמנה",
  "Service Fee": "דמי שירות",
  Tax: "מס",
  "Refunded {date}": "הוחזר ב-{date}",
  "Balance ({currency})": "יתרה ({currency})",
  "Total ({currency})": 'סה"כ ({currency})',
  "Billed to {address}": "חויב ל-{address}",
  // The single booking's own page — its duration and its cancellation dialog
  "{count} hours": "{count} שעות",
  "{count} days": "{count} ימים",
  "This booking is not refundable. Cancelling frees the room for someone else but returns nothing.":
    "ההזמנה הזו אינה ניתנת להחזר. ביטול מפנה את החדר למישהו אחר, אך לא מוחזר דבר.",
  "Cancel this booking for a full refund of {refund}.":
    "בטלו את ההזמנה הזו לקבלת החזר מלא של {refund}.",
  "Cancelling this booking returns {percentage}% of what you paid — {refund}.":
    "ביטול ההזמנה הזו מחזיר {percentage}% מהסכום ששילמתם — {refund}.",
  "Cancel this booking?": "לבטל את ההזמנה הזו?",
  "The room will be freed for someone else. This booking is not refundable, so nothing is returned.":
    "החדר יתפנה למישהו אחר. ההזמנה הזו אינה ניתנת להחזר, ולכן לא יוחזר דבר.",
  "The room will be freed for someone else and {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "החדר יתפנה למישהו אחר ו-{refund} מוחזרים לאמצעי התשלום שלכם. החזרים מופיעים תוך 5–10 ימי עסקים.",
  "The room will be freed for someone else and {refund} — {percentage}% of what you paid — is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "החדר יתפנה למישהו אחר ו-{refund} — {percentage}% מהסכום ששילמתם — מוחזרים לאמצעי התשלום שלכם. החזרים מופיעים תוך 5–10 ימי עסקים.",
  // The change flow — the hero's action and the three steps of its dialog
  "Change booking": "שינוי הזמנה",
  "This booking can no longer be changed. To move it, talk with the space directly.":
    "לא ניתן עוד לשנות את ההזמנה הזו. כדי להעביר אותה, דברו ישירות עם החלל.",
  "This booking could be changed until {deadline}. To move it, talk with the space directly.":
    "אפשר היה לשנות את ההזמנה הזו עד {deadline}. כדי להעביר אותה, דברו ישירות עם החלל.",
  "Move this booking": "העברת ההזמנה",
  "Pick a new date and time for {room}. Everything else about your booking stays as it is.":
    "בחרו תאריך ושעה חדשים ל-{room}. כל שאר הפרטים בהזמנה נשארים כפי שהם.",
  "This slot costs {price} for {duration}.":
    "המשבצת הזו עולה {price} עבור {duration}.",
  "This is the slot you already have. Pick a different date or time to move it.":
    "זו המשבצת שיש לכם כבר. בחרו תאריך או שעה אחרים כדי להעביר אותה.",
  "This slot costs {amount} more, charged when you confirm.":
    "המשבצת הזו עולה {amount} יותר, שייגבו בעת האישור.",
  "This slot costs {amount} more. Your {card} is charged when you confirm.":
    "המשבצת הזו עולה {amount} יותר. הסכום ייגבה מ{card} בעת האישור.",
  "This slot is cheaper. {amount} is refunded to your payment method.":
    "המשבצת הזו זולה יותר. {amount} מוחזרים לאמצעי התשלום שלכם.",
  "This slot is cheaper. {amount} is refunded to your {card}.":
    "המשבצת הזו זולה יותר. {amount} מוחזרים ל{card}.",
  "This slot is cheaper, but changes are not partially refunded. Your total stays {paid}.":
    "המשבצת הזו זולה יותר, אך שינויים אינם מוחזרים באופן חלקי. הסך הכול שלכם נשאר {paid}.",
  "Review charge": "בדיקת החיוב",
  "Review change": "בדיקת השינוי",
  "Keep current slot": "להשאיר את המשבצת הקיימת",
  "Move this booking and pay {extra}?": "להעביר את ההזמנה הזו ולשלם {extra}?",
  "Move this booking?": "להעביר את ההזמנה הזו?",
  Now: "עכשיו",
  "Moving to": "עובר ל",
  "Already paid": "כבר שולם",
  "New slot price": "מחיר המשבצת החדשה",
  "To charge now": "לחיוב עכשיו",
  "To refund": "להחזר",
  "Not refunded": "לא מוחזר",
  "Nothing to pay": "אין מה לשלם",
  "Your card is charged as soon as you confirm, and the booking moves once the charge goes through.":
    "הכרטיס שלכם מחוייב מיד עם האישור, וההזמנה עוברת ברגע שהחיוב מאושר.",
  "{amount} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "{amount} מוחזרים לאמצעי התשלום שלכם. החזרים מופיעים תוך 5–10 ימי עסקים.",
  "{amount} is refunded to your {card}. Refunds take 5–10 business days to appear.":
    "{amount} מוחזרים ל{card}. החזרים מופיעים תוך 5–10 ימי עסקים.",
  "Nothing is charged and nothing is refunded — only the date and time change.":
    "לא נגבה ולא מוחזר דבר — רק התאריך והשעה משתנים.",
  "Nothing is charged. The {amount} difference is not refunded, so your total stays {paid}.":
    "לא נגבה דבר. ההפרש של {amount} אינו מוחזר, ולכן הסך הכול שלכם נשאר {paid}.",
  "Pay {amount} and move": "לשלם {amount} ולהעביר",
  "Move booking": "להעביר את ההזמנה",
  "Your booking has moved": "ההזמנה שלכם הועברה",
  "Your new booking": "ההזמנה החדשה שלכם",
  "Charged to your {card}": "חוייב ל{card}",
  "Charged to your payment method": "חוייב לאמצעי התשלום שלכם",
  "Refunded to your {card}": "הוחזר ל{card}",
  "Refunded to your payment method": "הוחזר לאמצעי התשלום שלכם",
  "Total paid": 'סה"כ שולם',
  "A new confirmation is on its way to {email}.": "אישור חדש נשלח אל {email}.",
  "{network} ending {last4}": "{network} שמסתיים ב-{last4}",
  "This slot could not be priced. Try another date or time.":
    "לא ניתן היה לחשב מחיר למשבצת הזו. נסו תאריך או שעה אחרים.",
  "This booking could not be moved. Please try again.":
    "לא ניתן היה להעביר את ההזמנה הזו. נסו שוב.",
  // The recurring quote refusal banner — what the quote refused and the way out
  "This time is sold at a non-refundable rate, which cannot be part of a recurring booking. Try a different day or time, or book this date on its own.":
    "השעה הזו נמכרת בתעריף שאינו ניתן להחזר, שלא יכול להיות חלק מהזמנה חוזרת. נסו יום או שעה אחרים, או הזמינו את התאריך הזה בנפרד.",
  "This promo code makes the booking non-refundable, which cannot be part of a recurring booking. Remove the code, or book this date on its own.":
    "קוד הקופון הזה הופך את ההזמנה ללא ניתנת להחזר, ולכן היא לא יכולה להיות חלק מהזמנה חוזרת. הסירו את הקוד, או הזמינו את התאריך הזה בנפרד.",
  "Bookings at this time need the venue's approval, so they cannot repeat yet. Try a different day or time, or book this date on its own.":
    "הזמנות בשעה הזו דורשות אישור של המתחם, ולכן הן עדיין לא יכולות לחזור. נסו יום או שעה אחרים, או הזמינו את התאריך הזה בנפרד.",
  "The first date's start time has passed. Update the dates to keep this booking repeating.":
    "שעת ההתחלה של התאריך הראשון כבר עברה. עדכנו את התאריכים כדי שההזמנה תמשיך לחזור.",
  "The chosen dates no longer fit this room's booking window. Update the dates to keep this booking repeating.":
    "התאריכים שנבחרו כבר לא נכנסים בחלון ההזמנות של החדר הזה. עדכנו את התאריכים כדי שההזמנה תמשיך לחזור.",
  "A recurring booking needs at least 2 dates. Add another date, or book this date on its own.":
    "הזמנה חוזרת צריכה לפחות 2 תאריכים. הוסיפו תאריך נוסף, או הזמינו את התאריך הזה בנפרד.",
  "This room no longer offers recurring bookings. You can still book a single date.":
    "החדר הזה כבר לא מציע הזמנות חוזרות. עדיין אפשר להזמין תאריך בודד.",
  "We couldn't price this recurring booking. Try different dates, or book a single date instead.":
    "לא הצלחנו לתמחר את ההזמנה החוזרת הזו. נסו תאריכים אחרים, או הזמינו תאריך בודד.",
  "Update the dates": "עדכון התאריכים",
  "Book a single date instead": "הזמנת תאריך בודד",
  "Remove the promo code": "הסרת קוד הקופון",
  Repeat: "חזרה",
  "Ends after": "מסתיים לאחר",
  "Fewer bookings": "פחות הזמנות",
  "More bookings": "יותר הזמנות",
  "Checking your dates…": "בודקים את התאריכים שלכם…",
  "We couldn't check these dates. Try again.":
    "לא הצלחנו לבדוק את התאריכים האלה. נסו שוב.",
  "This date isn't available at this time.": "תאריך זה אינו זמין בשעה זו.",
  "This date and time can't repeat inside the booking window.":
    "תאריך ושעה אלה לא יכולים לחזור בתוך חלון ההזמנה.",
  "Tinted dates are your recurring booking.":
    "התאריכים המודגשים הם ההזמנה החוזרת שלכם.",
  "Review all {count} bookings": "סקירת כל {count} ההזמנות",
  "Review bookings": "סקירת ההזמנות",
  "Dates and repeat": "תאריכים וחזרה",
  "Choose a date": "בחרו תאריך",
  "Full-day booking: the daily rate has been applied":
    "הזמנה ליום מלא: הוחל התעריף היומי",
  Table: "טבלה",
  "Ask AI": "Ask AI",
  Beta: "בטא",
  "New chat": "צ'אט חדש",
  "Ask AI ran into a problem": "אירעה בעיה ב-Ask AI",
  "Reload the page to use Ask AI.": "טענו מחדש את הדף כדי להשתמש ב-Ask AI.",
  "Start a new chat, or reload the page if this keeps happening.":
    "התחילו צ'אט חדש, או טענו מחדש את הדף אם הבעיה חוזרת.",
  "We couldn't verify your sign-in. Try again or refresh the page.":
    "לא הצלחנו לאמת את ההתחברות שלך. נסו שוב או רעננו את הדף.",
  "You don't have access to Ask AI for this account.":
    "אין לך גישה ל-Ask AI בחשבון הזה.",
  "Ask AI is temporarily unavailable. Try again in a moment.":
    "Ask AI אינו זמין כרגע. נסו שוב בעוד רגע.",
  "Something went wrong while getting your answer.":
    "משהו השתבש בזמן הכנת התשובה.",
  "Couldn't reach Ask AI. Check your connection and try again.":
    "לא הצלחנו להתחבר ל-Ask AI. בדקו את החיבור ונסו שוב.",
  "The answer took too long.": "התשובה התעכבה יותר מדי.",
  "This conversation is too long. Start a new chat.":
    "השיחה הזו ארוכה מדי. התחילו צ'אט חדש.",
  "What would you like to know?": "מה תרצו לדעת?",
  "Ask about your orders, revenue and room usage.":
    "שאלו על ההזמנות, ההכנסות והשימוש בחדרים.",
  "Suggested questions": "שאלות מוצעות",
  "Suggested follow-up questions": "שאלות המשך מוצעות",
  "How many orders have we had this month?": "כמה הזמנות היו לנו החודש?",
  "What was our revenue in the last 30 days?":
    "מה היו ההכנסות שלנו ב-30 הימים האחרונים?",
  "Which product types are booked the most?":
    "אילו סוגי מוצרים מוזמנים הכי הרבה?",
  "How does this month's revenue compare with last month?":
    "איך ההכנסות החודש לעומת החודש הקודם?",
  "What was meeting-room utilization last month?":
    "מה הייתה התפוסה של חדרי הישיבות בחודש שעבר?",
  "What were last month's unbooked meeting-room hours worth?":
    "כמה היו שוות שעות חדרי הישיבות שלא הוזמנו בחודש שעבר?",
  "How does this month compare with last month?":
    "איך החודש הזה לעומת החודש הקודם?",
  "Ask AI conversation": "שיחה עם Ask AI",
  "Jump to latest": "מעבר להודעה האחרונה",
  "Thinking…": "חושבת…",
  "Complex questions can take up to a minute":
    "שאלות מורכבות יכולות לקחת עד דקה",
  "You stopped this answer": "עצרתם את התשובה הזו",
  Failed: "נכשל",
  Copy: "העתקה",
  "Answer copied": "התשובה הועתקה",
  "Good answer": "תשובה טובה",
  "Bad answer": "תשובה לא טובה",
  "What was good about this answer?": "מה היה טוב בתשובה הזו?",
  "What went wrong with this answer?": "מה לא היה בסדר בתשובה הזו?",
  Accurate: "מדויקת",
  Relevant: "רלוונטית",
  Detailed: "מפורטת",
  Other: "אחר",
  Inaccurate: "לא מדויקת",
  "Not relevant": "לא רלוונטית",
  "Too vague": "כללית מדי",
  "Comment (optional)": "הערה (לא חובה)",
  "Send feedback": "שליחת משוב",
  "Feedback sent": "המשוב נשלח",
  "Couldn't send your feedback. Try again.":
    "לא הצלחנו לשלוח את המשוב. נסו שוב.",
  "Ask a question": "שאלו שאלה",
  Send: "שליחה",
  Stop: "עצירה",
  "Answer ready": "התשובה מוכנה",
  "Ask AI from any page": "Ask AI מכל דף",
  "Get answers about your orders, revenue and room usage without leaving the page you're on.":
    "קבלו תשובות על ההזמנות, ההכנסות והשימוש בחדרים בלי לצאת מהדף שבו אתם נמצאים.",
  Shortcut: "קיצור מקשים",
  "Got it": "הבנתי",
  "Get insights on these orders": "קבלו תובנות על ההזמנות האלה",
  "Give me insights on these orders.": "אילו תובנות עולות מההזמנות האלה?",
  "Monthly report": "דוח חודשי",
  "On the 1st of each month": "ב-1 בכל חודש",
  "Last month's revenue, bookings and how full your rooms were, emailed to your team. Choose who gets it, or turn it off.":
    "ההכנסות, ההזמנות ותפוסת החדרים של החודש שעבר, נשלחים במייל לצוות שלך. בחרו מי מקבל אותו, או כבו אותו.",
  "Sent to your admins": "נשלח למנהלים שלך",
  "Monthly report saved.": "הדוח החודשי נשמר.",
  "Flexspace writes and sends this email on the 1st of each month — you choose who gets it.":
    "Flexspace כותבת ושולחת את המייל הזה ב-1 בכל חודש — אתם בוחרים מי מקבל אותו.",
  "Who gets it": "מי מקבל אותו",
  "With no one listed, it goes to your dashboard admins.":
    "אם אין אף אחד ברשימה, הוא נשלח למנהלי לוח הבקרה שלך.",
  Search: "חיפוש",
  "Review and sign agreement": "סקירה וחתימה על ההסכם",
  "Page {current} of {total}": "עמוד {current} מתוך {total}",
  "Zoom in": "הגדלה",
  "Zoom out": "הקטנה",
  "Membership agreement": "הסכם החברות",
  "Membership agreement (updated)": "הסכם החברות (מעודכן)",
  "Full legal name": "שם משפטי מלא",
  "Type your own full legal name, even if you are signing for a company. This signs the membership agreement.":
    "הקלידו את שמכם המשפטי המלא, גם אם אתם חותמים בשם חברה. כך נחתם הסכם החברות.",
  "After you pay, we'll email you the full agreement with your signature.":
    "לאחר התשלום נשלח אליכם בדוא״ל את ההסכם המלא עם החתימה שלכם.",
  "Scroll to the end and type your full legal name to continue.":
    "גללו עד הסוף והקלידו את שמכם המשפטי המלא כדי להמשיך.",
  "This agreement was updated while you were checking out. Please review the latest version and sign again.":
    "ההסכם עודכן בזמן שהשלמתם את ההזמנה. אנא עיינו בגרסה העדכנית וחתמו שוב.",
  "Please sign the membership agreement by typing your full legal name.":
    "אנא חתמו על הסכם החברות על ידי הקלדת שמכם המשפטי המלא.",
  "Please type your full legal name": "אנא הקלידו את שמכם המשפטי המלא",
  "The agreement could not be displayed here.": "לא ניתן להציג כאן את ההסכם.",
  "Open the agreement": "פתיחת ההסכם",
  "Higher rate": "תעריף גבוה יותר",
};
